import { Component, computed, inject, Input, input, OnInit, output } from "@angular/core";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { TranslatePipe } from "@ngx-translate/core";

import { Language } from "../../../constants/enums";
import { SmartToolTipsDirective } from "../../../directives";
import { FormTab } from "../../../models";
import { AppService, LanguageService } from "../../../services";

@Component({
  selector: "adaa-form-steps",
  imports: [TranslatePipe, FontAwesomeModule, SmartToolTipsDirective],
  templateUrl: "./form-steps.html",
  styleUrl: "./form-steps.scss",
})
export class FormStepsComponent implements OnInit {
  readonly tabs = input<FormTab[]>([]);
  @Input() activeTab: number = 0;
  readonly showSaveButton = input<boolean>(true);
  readonly showFinishButton = input<boolean>(false);
  readonly showActions = input<boolean>(true);
  readonly showTabIndex = input<boolean>(true);
  readonly cancelTitle = input<string>("common.form.button.cancel");
  readonly saveTitle = input<string>("common.form.button.save");
  readonly finishTitle = input<string>("common.form.button.finish");
  currentTab = output<number>();
  cancelClicked = output<boolean>();
  submitClicked = output<boolean>(); //TRUE finish FALSE save

  appService = inject(AppService);
  languageService = inject(LanguageService);
  private _iconLibrary: FaIconLibrary = inject(FaIconLibrary);

  language = Language;

  readonly lastTab = computed(() => {
    const tabs = this.tabs();
    return tabs.length ? tabs.map((e) => !e.disabled).lastIndexOf(true) : -1;
  });

  public ngOnInit(): void {
    this._iconLibrary.addIcons(faArrowLeft, faArrowRight);
  }

  public tabSelected(index: number): void {
    this.activeTab = index;
    this.currentTab.emit(this.activeTab);
  }

  public moveBack(): void {
    const stepIndex = this._getFirstLastNotDisabledTab(true);
    if (stepIndex > -1) this.tabSelected(stepIndex);
  }

  public moveNext(): void {
    const stepIndex = this._getFirstLastNotDisabledTab(false);
    if (stepIndex > -1) this.tabSelected(stepIndex);
  }

  private _getFirstLastNotDisabledTab(isFirst: boolean) {
    const tabs = this.tabs();
    if (isFirst) {
      for (let i = this.activeTab - 1; i >= 0; i--) {
        if (!tabs[i].disabled) return i;
      }
    } else {
      for (let i = this.activeTab + 1; i < tabs.length; i++) {
        if (!tabs[i].disabled) return i;
      }
    }
    return -1;
  }
}
